import React, { useState, useContext, createContext, useEffect } from 'react';
import { techSignIn, techSignUp, techSignOut, getTechSession, onTechAuthChange, getTechProfile, upsertTechProfile } from '../services/chatService';

const TechAuthContext = createContext({});

export function TechAuthProvider({ children }) {
  const [techUser, setTechUser] = useState(null);
  const [techProfile, setTechProfile] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getTechSession()?.then((session) => {
      setTechUser(session?.user ?? null);
      if (session?.user) loadTechProfile(session?.user?.id);
      else setLoading(false);
    });

    const { data: { subscription } } = onTechAuthChange((event, session) => {
      setTechUser(session?.user ?? null);
      if (session?.user) loadTechProfile(session?.user?.id);
      else { setTechProfile(null); setLoading(false); }
    });

    return () => subscription?.unsubscribe();
  }, []);

  const loadTechProfile = async (userId) => {
    try {
      const profile = await getTechProfile(userId);
      setTechProfile(profile);
    } catch (e) {
      console.error('Error loading tech profile:', e);
    } finally {
      setLoading(false);
    }
  };

  const login = async (email, password) => {
    const data = await techSignIn(email, password);
    return data;
  };

  const register = async (email, password, meta) => {
    const data = await techSignUp(email, password, meta);
    if (data?.user) {
      await upsertTechProfile(data?.user?.id, {
        full_name: meta?.full_name || '',
        facility: meta?.facility || '',
        specialization: meta?.specialization || '',
        email,
      });
    }
    return data;
  };

  const logout = async () => {
    await techSignOut();
    setTechUser(null);
    setTechProfile(null);
  };

  return (
    <TechAuthContext.Provider value={{ techUser, techProfile, loading, login, register, logout, loadTechProfile }}>
      {children}
    </TechAuthContext.Provider>
  );
}

export function useTechAuth() {
  return useContext(TechAuthContext);
}
